
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/portfolio/[shareSlug]",
      function () {
        return require("private-next-pages/app/portfolio/[shareSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/portfolio/[shareSlug]"])
      });
    }
  